import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[formFocusable]'
})
export class FormFocusableDirective implements OnInit {
  focusables = ['input', 'select', 'textarea'];

  constructor(private element: ElementRef) {}

  ngOnInit(): void {
    const input = this.element.nativeElement.querySelector(this.focusables.join(','));
    if (input) {
      input.focus();
    }
  }

  @HostListener('submit')
  submit() {
    const input = this.element.nativeElement.querySelector(
      this.focusables.map((x) => `${x}.ng-invalid`).join(',')
    );
    if (input) {
      input.focus();
    }
  }
}
